<ejs-grid #grid
          class="grid-with-toolbar grid-no-filter grid-configuration"
          width="100%"
          rowHeight="38"
          [dataSource]="data"
          [allowSorting]="true"
          [allowPaging]="true"
          [allowFiltering]="true"
          [pageSettings]='pageSettings'
          [filterSettings]="filterSettings"
          (rowSelected)="onRowSelected($event)"
          (recordDoubleClick)="onRecordDoubleClick($event)"
          (dataBound)="onDataBound()">
  <e-columns>
    <e-column field="id"
              [visible]="false"
              [isPrimaryKey]="true"></e-column>
    <e-column field="templateName"
              headerText="{{'i18n.domain.export-configuration.shared.column-headers.template' | translate}}"
              clipMode="EllipsisWithTooltip">  
    </e-column>
  </e-columns>
</ejs-grid>
